import React, { FC } from 'react';
import classnames from 'classnames/bind';

import styles from './articlePreviewStyles.scss';
import UserGeneratedLink from '@buyside/components/presentation/UserGeneratedLink/UserGeneratedLink';

import { OpenGraphDataQuery } from '@interfaces/graphql-typings';

const cx = classnames.bind(styles);

const ArticlePreview: FC<Partial<OpenGraphDataQuery['openGraphData']> & { form?: boolean }> = ({
  domain,
  ogDescription,
  ogPreviewImageUrl,
  ogTitle,
  ogUrl,
  form = false
}) => {
  if (!ogUrl || !ogTitle || !ogDescription || !ogPreviewImageUrl) return null;
  const articlePreviewClass = cx({
    articlePreviewArea: true,
    form
  });
  return (
    <UserGeneratedLink href={ogUrl}>
      <div data-testid="parent-div" className={articlePreviewClass}>
        <div className={styles.articlePreviewImageWrap}>
          <img className={styles.articlePreviewImage} src={ogPreviewImageUrl} alt="Preview Image" />
        </div>
        <div className={styles.articlePreviewContent}>
          <h4>{ogTitle}</h4>
          <p>{ogDescription}</p>
        </div>
        <p className={styles.articlePreviewCitation}>{domain}</p>
      </div>
    </UserGeneratedLink>
  );
};

export default ArticlePreview;
